import { PlatformLocation, isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, PLATFORM_ID, computed, inject, input, signal } from '@angular/core';
import { cuentaAtras } from 'src/app/utils/once-once';

/**
 * La landing /11-11/ y las fichas cuya ruta lleva «11-11» como tramo (la recopilación de chollos
 * del 11.11 de AliExpress) ya dicen lo que dice la franja (04/11/2026). Sólo cuenta la ruta: una
 * búsqueda `?search=11-11` no es la página del 11.11.
 */
export function rutaHablaDelOnce(url: string | null | undefined): boolean {
  const ruta = (url || '').split(/[?#]/)[0];
  return /(^|[\/-])11-11([\/-]|$)/.test(ruta);
}

/**
 * Franja «Promo del 11.11» (diseño 5, 02/11/2026) bajo la cabecera de toda la web, con la cuenta
 * atrás, que lleva a /11-11/ (02/11/2026). No sale en la propia landing, en las fichas del 11.11
 * ni cuando acaba. La ruta llega por `url` (AppComponent, en cada NavigationEnd del Router) y,
 * hasta entonces, de la petición (SSR).
 */
@Component({
  selector: 'app-franja-once',
  templateUrl: './franja-once.component.html',
  styleUrls: ['./franja-once.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FranjaOnceComponent {
  readonly url = input<string>('');
  readonly ahora = signal(Date.now());
  readonly cuenta = computed(() => cuentaAtras(this.ahora()));
  // Sin `url` todavía (en el servidor el primer NavigationEnd llega antes de que AppComponent se
  // suscriba), la ruta se toma de la petición: si no, el SSR de /11-11/ traía la franja y al
  // arrancar desaparecía, con salto del contenido (02/11/2026).
  private readonly rutaInicial = inject(PlatformLocation, { optional: true })?.pathname ?? '';
  readonly visible = computed(() => this.cuenta().fase !== 'despues' && !rutaHablaDelOnce(this.url() || this.rutaInicial));

  constructor() {
    if (isPlatformBrowser(inject(PLATFORM_ID))) {
      const reloj = setInterval(() => this.ahora.set(Date.now()), 30_000);
      inject(DestroyRef).onDestroy(() => clearInterval(reloj));
    }
  }
}
